import React, {useEffect, useState} from "react";
import {Link, withRouter} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import {Dropdown, DropdownMenu, DropdownToggle} from "reactstrap";
import {COLLAPSED_DRAWER, FIXED_DRAWER} from "constants/ActionTypes";
import {switchLanguage, toggleCollapsedNav, changeTitle} from "actions/Setting";
import IntlMessages from "util/IntlMessages";
import back from '../../../../assets/images/arrow.png';
import add from '../../../../assets/images/addbutton.png';
import call from "../../../../assets/images/call2.png";
import Button from "@material-ui/core/Button";
import {todayreserve} from "../../../../api/api";
import {saveDamane} from "../../../../actions";
import {isIOS, isMobile} from "react-device-detect";
import {driver} from 'driver.js';
import {type} from "@amcharts/amcharts4/core";

function toPersianNum(num, dontTrim) {

    if (num == null) {
        return '۰'
    }

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
}

const Index = (props) => {

    const dispatch = useDispatch();
    const {navCollapsed} = useSelector(({common}) => common);
    const {drawerType, locale, title} = useSelector(({settings}) => settings);
    const [langSwitcher, setLangSwitcher] = useState(false);
    const [mailNotification, setMailNotification] = useState(false);
    const [appNotification, setAppNotification] = useState(false);
    const [searchBox, setSearchBox] = useState(false);
    const [apps, setApps] = useState(false);
    const [showdamane, setShowdamane] = useState(false);
    const [updateon, setUpdateon] = useState(false);
    const [searchText, setSearchText] = useState('');
    const {damane, update} = useSelector(({auth}) => auth);


    useEffect(() => {

        if (damane === '' || damane === null) {
            setShowdamane(false);
        } else {
            setShowdamane(true);
        }
    }, [damane]);

    useEffect(() => {
        if (update > 0) {
            setUpdateon(true);
        } else {
            setUpdateon(false);
        }

    }, [update]);

    const startTour = () => {
        const driverObj = driver({
            rtl: true, // مستقیم RTL فعال می‌شه (فلش‌ها، موقعیت‌ها و متن فلیپ می‌شن)
            showProgress: true, // نمایش پیشرفت (مثل گام ۱ از ۵)
            allowClose: true, // اجازه بستن با ESC یا کلیک بیرون
            overlayColor: 'rgba(0,0,0,0.6)', // رنگ ماسک
            stagePadding: 10, // فاصله highlight
            nextBtnText: 'بعدی',
            prevBtnText: 'قبلی',
            doneBtnText: 'پایان',
            closeBtnText: 'رد کردن',
            onDestroyed: () => {  // وقتی تور کامل شد یا بسته شد
                // localStorage.setItem("header", 'true');
            },
            steps: [
                {
                    element: '.update', // سلکتور المان
                    popover: {
                        title: 'اپدیت در سایت ها',
                        description: 'برای دسترسی آسان شما اپدیت این دکمه در تمامی صفحات مجود می باشد. در این بخش فقط کافیه با شماره ای که در سایت ها ثبت نام کردید با کلیک بر روی دکمه های اتصال وارد کردن شماره ، اتصال شما با سایت ها برقرار میشود و به راحتی تقویم یکپارچه شما درست میشود.',
                        side: 'top', // موقعیت (در RTL خودکار تنظیم می‌شه)
                        align: 'start'
                    }
                },
            ]
        });

        driverObj.drive(); // شروع تور
    };

    useEffect(() => {
        if (localStorage.getItem('update') == null) {
            // alert('act')
            localStorage.setItem('update', 0)
        }

        // if (props.type === 5) {
        //     const pageKey = 'header';
        //     const hasSeenTour = localStorage.getItem(pageKey) === 'true';
        //     if (!hasSeenTour) {
        //         startTour();
        //     } else {
        //
        //     }
        // }


    }, []);


    const onAppNotificationSelect = () => {
        setAppNotification(!appNotification)
    };

    const onMailNotificationSelect = () => {
        setMailNotification(!mailNotification)
    };
    const onLangSwitcherSelect = (event) => {
        setLangSwitcher(!langSwitcher);
    };

    const onSearchBoxSelect = () => {
        setSearchBox(!searchBox)
    };
    const onAppsSelect = () => {
        setApps(!apps)
    };
    const openInNewTab = url => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    const onClick = () => {

        if (props.type === 0) {

            props.history.push('/app/homes/new');
        }

        if (props.type === 1) {
            // alert(localStorage.getItem('id'));
            props.history.push('/app/reserves/new/0');
        }

        if (props.type === 3) {

            // alert(localStorage.getItem('id'));
            props.history.push('/app/reserves/new/0');
        }

        if (props.type === 4) {

            // alert(localStorage.getItem('id'));
            // openInNewTab(props.link);
            props.history.push('/app/connectsites');
        }

        if (props.type === 5) {

            // alert(localStorage.getItem('id'));
            // openInNewTab(props.link);
            props.history.push('/app/connectsites');
        }

    };

    const onClick2 = () => {

        props.history.push('/app/connectsites');

    }

    const onClick4 = () => {

        props.history.push('/app/homes/new');

    }


    const handleRequestClose = () => {
        setSearchBox(false);
        setLangSwitcher(false);
        setMailNotification(false);
        setSearchBox(false);
        setApps(false);
    };

    const onToggleCollapsedNav = (e) => {
        const val = !navCollapsed;
        dispatch(toggleCollapsedNav(val));
    };


    const Apps = () => {
        return (
            <ul className="jr-list jr-list-half">
                <li className="jr-list-item">
                    <Link className="jr-list-link" to="/app/calendar/basic">
                        <i className="zmdi zmdi-calendar zmdi-hc-fw"/>
                        <span className="jr-list-text"><IntlMessages id="sidebar.calendar.basic"/></span>
                    </Link>
                </li>

                <li className="jr-list-item">
                    <Link className="jr-list-link" to="/app/to-do">
                        <i className="zmdi zmdi-check-square zmdi-hc-fw"/>
                        <span className="jr-list-text"><IntlMessages id="sidebar.appModule.toDo"/></span>
                    </Link>
                </li>

                <li className="jr-list-item">
                    <Link className="jr-list-link" to="/app/mail">
                        <i className="zmdi zmdi-email zmdi-hc-fw"/>
                        <span className="jr-list-text"><IntlMessages id="sidebar.appModule.mail"/></span>
                    </Link>
                </li>

                <li className="jr-list-item">
                    <Link className="jr-list-link" to="/app/chat">
                        <i className="zmdi zmdi-comment zmdi-hc-fw"/>
                        <span className="jr-list-text"><IntlMessages id="sidebar.appModule.chat"/></span>
                    </Link>
                </li>

                <li className="jr-list-item">
                    <Link className="jr-list-link" to="/app/contact">
                        <i className="zmdi zmdi-account-box zmdi-hc-fw"/>
                        <span className="jr-list-text"><IntlMessages id="sidebar.appModule.contact"/></span>
                    </Link>
                </li>

                <li className="jr-list-item">
                    <Link className="jr-list-link" to="/">
                        <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw"/>
                        <span className="jr-list-text">Add New</span>
                    </Link>
                </li>
            </ul>);
    };


    const updateSearchText = (evt) => {
        setSearchText(evt.target.value);
    };

    const onSwitchLanguage = (lang) => {
        dispatch(switchLanguage(lang))
    };

    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? "d-block d-xl-none" : drawerType.includes(COLLAPSED_DRAWER) ? "d-block" : "d-none";
    const drawerStyle0 = drawerType.includes(FIXED_DRAWER) ? " d-block d-xl-none" : drawerType.includes(COLLAPSED_DRAWER) ? "d-none" : "d-block";

    const getComponent = () => {
        switch (props.type) {
            case 0:
                return <div style={{position: 'absolute', left: 10, top: 10, display: 'flex'}}>

                    {/*<Button style={{marginLeft: 5, backgroundColor: '#00cdff'}} onClick={onClick2} variant="contained"*/}
                    {/*        className=" text-black iran-font">*/}
                    {/*    <div style={{color: '#ffffff', fontWeight: 'bold'}}>*/}
                    {/*        پیش نمایش*/}
                    {/*    </div>*/}
                    {/*</Button>*/}

                    <div>
                        {updateon ?
                            <Button
                                style={{marginLeft: 4, paddingRight: 4, paddingLeft: 4, backgroundColor: '#e2203d'}}
                                onClick={onClick2} variant="contained"
                                className="update text-black iran-font">
                                <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                    آپدیت در سایت ها ({toPersianNum(update)})
                                </div>
                            </Button>
                            :
                            <Button
                                style={{marginLeft: 4, paddingRight: 4, paddingLeft: 4, backgroundColor: '#00cdff'}}
                                onClick={onClick2} variant="contained"
                                className="update text-black iran-font">
                                <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                    آپدیت در سایت ها
                                </div>
                            </Button>
                        }
                    </div>


                    <Button style={{marginLeft: 2, paddingRight: 4, paddingLeft: 4, backgroundColor: '#00cdff'}}
                            onClick={onClick} variant="contained"
                            className="text-white iran-font">
                        {/*<div>*/}
                        {/*    <img src={add} style={{width: 20, marginLeft: 2, height: 20}}></img>*/}
                        {/*</div>*/}
                        <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                            افزودن اقامتگاه
                        </div>
                    </Button>


                </div>
            case 1:
                return <div style={{position: 'absolute', left: 10, top: 10}}>
                    {/*{isMobile ?*/}
                    {/*    null*/}
                    {/*    :*/}
                    {/*    <div>*/}
                    {/*        */}
                    {/*    </div>*/}
                    {/*}*/}
                    {updateon ?
                        <Button
                            style={{marginLeft: 4, paddingRight: 4, paddingLeft: 4, backgroundColor: '#e2203d'}}
                            onClick={onClick2} variant="contained"
                            className="update text-black iran-font">
                            <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                آپدیت در سایت ها ({toPersianNum(update)})
                            </div>
                        </Button>
                        :
                        <Button
                            style={{marginLeft: 4, paddingRight: 4, paddingLeft: 4, backgroundColor: '#00cdff'}}
                            onClick={onClick2} variant="contained"
                            className="update text-black iran-font">
                            <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                آپدیت در سایت ها
                            </div>
                        </Button>
                    }
                    <Button style={{marginLeft: 5, paddingRight: 4, paddingLeft: 4, backgroundColor: '#00cdff'}}
                            onClick={onClick} variant="contained"
                            className=" text-white iran-font">
                        {/*<div>*/}
                        {/*    <img src={add} style={{width: 20, marginLeft: 10, height: 20}}></img>*/}
                        {/*</div>*/}
                        <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                            افزودن رزرو
                        </div>
                    </Button>
                </div>


            case 3:
                return <div style={{position: 'absolute', left: 10, top: 10}}>
                    {/*<Button style={{marginLeft: 5, backgroundColor: '#00cdff'}} onClick={onClick2} variant="contained"*/}
                    {/*        className=" text-black iran-font">*/}
                    {/*    <div style={{color: '#ffffff', fontWeight: 'bold'}}>*/}
                    {/*        پیش نمایش*/}
                    {/*    </div>*/}
                    {/*</Button>*/}
                    <Button style={{marginLeft: 5, backgroundColor: '#00cdff'}} onClick={onClick} variant="contained"
                            className=" text-white iran-font">

                        {/*<Link to={{*/}
                        {/*pathname: '/app/homes/new',*/}
                        {/*}} style={{color: '#ffffff'}}>*/}
                        {/**/}
                        {/*</Link>*/}

                        {/*<div>*/}

                        {/*    <img src={add} style={{width: 20, marginLeft: 10, height: 20}}></img>*/}


                        {/*</div>*/}
                        <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                            افزودن رزرو
                        </div>


                    </Button>
                </div>

            case 4:
                // return <div style={{position: 'absolute', left: 10, top: 10}}>
                //     <Button style={{marginLeft: 5, backgroundColor: '#00cdff'}} onClick={onClick} variant="contained"
                //             className=" text-black iran-font">
                //
                //         {/*<Link to={{*/}
                //         {/*pathname: '/app/homes/new',*/}
                //         {/*}} style={{color: '#ffffff'}}>*/}
                //         {/**/}
                //         {/*</Link>*/}
                //
                //         {/*<div>*/}
                //
                //         {/*    <img src={add} style={{width: 20, marginLeft: 10, height: 20}}></img>*/}
                //
                //
                //         {/*</div>*/}
                //         <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                //             پیش نمایش
                //         </div>
                //
                //
                //     </Button>
                // </div>
                return <div style={{position: 'absolute', left: 10, top: 10}}>
                    {
                        updateon ?
                            <Button
                                style={{
                                    marginLeft: 4,
                                    paddingRight: 4,
                                    paddingLeft: 4,
                                    backgroundColor: '#e2203d'
                                }}
                                onClick={onClick2} variant="contained"
                                className="update text-black iran-font">
                                <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                    آپدیت در سایت ها ({toPersianNum(update)})
                                </div>
                            </Button>
                            :
                            <Button
                                style={{
                                    marginLeft: 4,
                                    paddingRight: 4,
                                    paddingLeft: 4,
                                    backgroundColor: '#00cdff'
                                }}
                                onClick={onClick2} variant="contained"
                                className="update text-black iran-font">
                                <div style={{color: '#ffffff', fontWeight: 'bold', fontSize: 12}}>
                                    آپدیت در سایت ها
                                </div>
                            </Button>
                    }

                </div>
            case 5:
                return <div style={{position: 'absolute', left: 10, top: 10}} className="update">

                    {showdamane ?
                        <div >
                            {updateon ?
                                <Button
                                    style={{
                                        marginLeft: 4,
                                        paddingRight: 4,
                                        paddingLeft: 4,
                                        backgroundColor: '#e2203d'
                                    }}
                                    onClick={onClick2} variant="contained"
                                    className=" text-black iran-font">
                                    <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                        آپدیت در سایت ها ({toPersianNum(update)})
                                    </div>
                                </Button>
                                :
                                <Button
                                    style={{
                                        marginLeft: 4,
                                        paddingRight: 4,
                                        paddingLeft: 4,
                                        backgroundColor: '#00cdff'
                                    }}
                                    onClick={onClick2} variant="contained"
                                    className=" text-black iran-font">
                                    <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                        آپدیت در سایت ها
                                    </div>
                                </Button>
                            }

                        </div>


                        :

                        <Button style={{marginLeft: 5, backgroundColor: '#00cdff'}} onClick={onClick4}
                                variant="contained"
                                className="text-white iran-font">
                            {/*<div>*/}
                            {/*    <img src={add} style={{width: 20, marginLeft: 10, height: 20}}></img>*/}
                            {/*</div>*/}
                            <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                افزودن اقامتگاه
                            </div>
                        </Button>

                    }


                </div>


        }

    };


    const funcback = () => {
        props.history.goBack();
    };


    return (
        <AppBar style={{height: 55}} className="app-main-header">
            <Toolbar className="app-toolbar" style={{minHeight: 0}} disableGutters={false}>

                <IconButton className={`jr-menu-icon mr-3 ${drawerStyle}`} aria-label="Menu"
                            onClick={onToggleCollapsedNav}>
                    <span className="menu-icon"/>
                </IconButton>


                <div className={` d-sm-block  `} style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    fontSize: 15,
                    fontFamily: 'iransans'
                }}>
                    {props.title}
                </div>

                {props.back ?

                    <div className={`app-logo mr-2 jr-menu-icon mr-3 d-sm-block  `} style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        position: 'absolute',
                        left: 10,
                        alignItems: 'center',
                        fontWeight: 'bold',
                        fontFamily: 'iransans'
                    }}>
                        <div onClick={funcback} style={{margin: '0 auto', cursor: 'pointer'}}>
                            <img src={back} style={{width: 20, height: 20}}></img>
                        </div>
                    </div>

                    :

                    // <div className={`app-logo mr-2 jr-menu-icon mr-3 d-sm-block ${drawerStyle} `} style={{
                    //     display: 'flex',
                    //     flexDirection: 'row',
                    //     justifyContent: 'center',
                    //     position: 'absolute',
                    //     left: 10,
                    //     alignItems: 'center',
                    //     fontWeight: 'bold',
                    //     fontFamily: 'iransans'
                    // }}>
                    //     <div onClick={onClick} style={{margin: '0 auto', cursor: 'pointer'}}>
                    //         <img src={add} style={{width: 20, height: 20}}></img>
                    //     </div>
                    // </div>
                    <div>{getComponent()}

                    </div>


                }


                {/*<Link className={`app-logo mr-2 jr-menu-icon mr-3 d-sm-block ${drawerStyle0}`} to="/">*/}
                {/*  <img src={require("assets/images/logo.png")} alt="Jambo" title="Jambo"/>*/}
                {/*</Link>*/}


                {/*<SearchBox styleName="d-none d-lg-block" placeholder=""*/}
                {/*           onChange={updateSearchText}*/}
                {/*           value={searchText}/>*/}


                {/*<ul className="header-notifications list-inline ml-auto">*/}
                {/*<li className="list-inline-item">*/}
                {/*<Dropdown*/}
                {/*className="quick-menu app-notification"*/}
                {/*isOpen={apps}*/}
                {/*toggle={onAppsSelect}>*/}

                {/*<DropdownToggle*/}
                {/*className="d-inline-block"*/}
                {/*tag="span"*/}
                {/*data-toggle="dropdown">*/}
                {/*<span className="app-notification-menu">*/}
                {/*<i className="zmdi zmdi-apps zmdi-hc-fw zmdi-hc-lg"/>*/}
                {/*<span>Apps</span>*/}
                {/*</span>*/}
                {/*</DropdownToggle>*/}

                {/*<DropdownMenu>*/}
                {/*{Apps()}*/}
                {/*</DropdownMenu>*/}
                {/*</Dropdown>*/}
                {/*</li>*/}
                {/*<li className="d-inline-block d-lg-none list-inline-item">*/}
                {/*<Dropdown*/}
                {/*className="quick-menu nav-searchbox"*/}
                {/*isOpen={searchBox}*/}
                {/*toggle={onSearchBoxSelect}>*/}

                {/*<DropdownToggle*/}
                {/*className="d-inline-block"*/}
                {/*tag="span"*/}
                {/*data-toggle="dropdown">*/}
                {/*<IconButton className="icon-btn">*/}
                {/*<i className="zmdi zmdi-search zmdi-hc-fw"/>*/}
                {/*</IconButton>*/}
                {/*</DropdownToggle>*/}

                {/*<DropdownMenu right className="p-0">*/}
                {/*<SearchBox styleName="search-dropdown" placeholder=""*/}
                {/*onChange={updateSearchText}*/}
                {/*value={searchText}/>*/}
                {/*</DropdownMenu>*/}
                {/*</Dropdown>*/}
                {/*</li>*/}
                {/*<li className="list-inline-item">*/}
                {/*<Dropdown*/}
                {/*className="quick-menu"*/}
                {/*isOpen={langSwitcher}*/}
                {/*toggle={onLangSwitcherSelect}>*/}

                {/*<DropdownToggle*/}
                {/*className="d-inline-block"*/}
                {/*tag="span"*/}
                {/*data-toggle="dropdown">*/}
                {/*<IconButton className="icon-btn">*/}
                {/*<i className={`flag flag-24 flag-${locale.icon}`}/>*/}
                {/*</IconButton>*/}
                {/*</DropdownToggle>*/}

                {/*<DropdownMenu right className="w-50">*/}
                {/*<LanguageSwitcher switchLanguage={onSwitchLanguage}*/}
                {/*handleRequestClose={handleRequestClose}/>*/}
                {/*</DropdownMenu>*/}
                {/*</Dropdown>*/}


                {/*</li>*/}
                {/*<li className="list-inline-item app-tour">*/}
                {/*<Dropdown*/}
                {/*className="quick-menu"*/}
                {/*isOpen={appNotification}*/}
                {/*toggle={onAppNotificationSelect}>*/}

                {/*<DropdownToggle*/}
                {/*className="d-inline-block"*/}
                {/*tag="span"*/}
                {/*data-toggle="dropdown">*/}
                {/*<IconButton className="icon-btn">*/}
                {/*<i className="zmdi zmdi-notifications-none icon-alert animated infinite wobble"/>*/}
                {/*</IconButton>*/}
                {/*</DropdownToggle>*/}

                {/*<DropdownMenu right>*/}
                {/*<CardHeader styleName="align-items-center"*/}
                {/*heading={<IntlMessages id="appNotification.title"/>}/>*/}
                {/*<AppNotification/>*/}
                {/*</DropdownMenu>*/}
                {/*</Dropdown>*/}
                {/*</li>*/}
                {/*<li className="list-inline-item mail-tour">*/}
                {/*<Dropdown*/}
                {/*className="quick-menu"*/}
                {/*isOpen={mailNotification}*/}
                {/*toggle={onMailNotificationSelect}*/}
                {/*>*/}
                {/*<DropdownToggle*/}
                {/*className="d-inline-block"*/}
                {/*tag="span"*/}
                {/*data-toggle="dropdown">*/}

                {/*<IconButton className="icon-btn">*/}
                {/*<i className="zmdi zmdi-comment-alt-text zmdi-hc-fw"/>*/}
                {/*</IconButton>*/}
                {/*</DropdownToggle>*/}


                {/*<DropdownMenu right>*/}
                {/*<CardHeader styleName="align-items-center"*/}
                {/*heading={<IntlMessages id="mailNotification.title"/>}/>*/}
                {/*<MailNotification/>*/}
                {/*</DropdownMenu>*/}
                {/*</Dropdown>*/}
                {/*</li>*/}

                {/*</ul>*/}

                <div className="ellipse-shape"/>
            </Toolbar>
        </AppBar>
    );
};


export default withRouter(Index);
